import { render, staticRenderFns } from "./orgCheckUploadFile.vue?vue&type=template&id=32852b16&scoped=true"
import script from "./orgCheckUploadFile.vue?vue&type=script&lang=js"
export * from "./orgCheckUploadFile.vue?vue&type=script&lang=js"
import style0 from "./orgCheckUploadFile.vue?vue&type=style&index=0&id=32852b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32852b16",
  null
  
)

export default component.exports